module.exports = __webpack_public_path__ + "535980f44eeba13fca471178ff86716b.svg";